var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Next(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C3CCD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74642 5.992C8.07842 5.992 6.99842 7.108 6.99842 8.788L7.01042 9.004H8.03042V8.92C8.03042 7.756 8.64242 6.892 9.68642 6.892C10.6104 6.892 11.3304 7.54 11.3304 8.44C11.3304 8.92 11.1984 9.328 10.9224 9.676C10.6584 10.012 10.0224 10.504 9.03842 11.092C8.21042 11.596 7.62242 12.112 7.31042 12.64C7.01042 13.18 6.83042 13.792 6.77042 14.5H12.3264V13.6H7.95842C8.07842 12.94 8.52242 12.412 9.83042 11.656C10.8984 11.044 11.5944 10.504 11.9184 10.024C12.2424 9.556 12.4104 9.028 12.4104 8.44C12.4104 6.94 11.3184 5.992 9.74642 5.992Z",
    fill: "#0D1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Next);
export default __webpack_public_path__ + "static/media/2-next.98c50beba34681de22c8a2fa0267099a.svg";
export { ForwardRef as ReactComponent };